import graphql__7788fa0e3f4d381f95ad from "./__generated__/ResendPhoneNumberCodeMutation.graphql.js";import { commitMutation, graphql } from "react-relay";

import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__7788fa0e3f4d381f95ad;

async function resendPhoneNumberCode() {
  return new Promise((resolve, reject) => {
    commitMutation(appRelayEnvironment, {
      mutation,
      variables: {},
      onCompleted: (response, errors) => {
        if (errors) {
          reject(errors);
        } else {
          resolve(response);
        }
      },
      onError: error => reject(error)
    });
  });
}

export { resendPhoneNumberCode };
